<template>
  <div class="pop-payment-wrap">
    <div class="pop-header">
      <span class="pop-title">영수증 상세</span>
      <button class="btn-pop-close" @click="$.emit('close')">
        닫기<span class="overlay"></span>
      </button>
      <button class="btn-pop-back" @click="$.emit('close')">
        뒤로<span class="overlay"></span>
      </button>
    </div>
    <div class="pop-body">
      <div class="flex">
        <div class="receipt-wrap" id="receiptArea">
          <div class="receipt-shd" style="height: max-content">
            여러분과 함께하는 총판POS <br />
            점 포 명: 회현점<br />
            대 표 자:홍길동 <br />
            사업자번호:120-86-00000 <br />
            전 화 번호:000-0000-0000<br />
            서울특별시 강남구 압구정로 10길 22 OO빌딩 2층<br /><br />
            {{ receipt.receiptDate }} {{ receipt.receiptTime }} <br />
            거래번호:{{ receipt.receiptNo }}<br /><br />
            <div
              style="
                width: 100%;
                border-top: 1px dashed #000;
                border-bottom: 1px dashed #000;
                padding: 0 2px;
              "
            >
              <table style="width: 100%; margin: 10px 0">
                <colgroup>
                  <col style="width: 40%" />
                  <col style="width: 20%" />
                  <col style="width: 20%" />
                  <col style="width: 20%" />
                </colgroup>
                <tr>
                  <td>상품명</td>
                  <td>단가</td>
                  <td>수량</td>
                  <td>금액</td>
                </tr>
                <tr v-for="menu in menuArr" :key="menu">
                  <td>{{ menu.name }}</td>
                  <td>
                    {{
                      menu.price
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}
                  </td>
                  <td>{{ menu.qty }}</td>
                  <td>
                    {{
                      (menu.qty * menu.price)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}
                  </td>
                </tr>
              </table>
            </div>
            <div
              style="
                width: 100%;
                border-bottom: 1px dashed #000;
                padding: 10px 2px;
              "
            >
              합 계
              {{
                receipt.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}
              <br />
              받은금액
              {{
                receipt.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}
              <br />
              해외마스타 M 524689******4703 <br />
              승인번호 051961 일시불
            </div>
            <div style="width: 100%; padding: 10px 2px">
              캐셔No : 12***01001 조*흠 202303025010100010011457 <br />
              원산지 표기를 지킵시다 <br />
              무료주차시간이 적용되었습니다 <br />
              교환 및 환불은 영수증과 원거래 결제 수단 지참 후 14일 이내에
              가능합니다.<br />
              단, 환불은 구입하신 매장에서만 가능합니다.
            </div>
          </div>
        </div>
        <div class="tb-side-btn">
          <button
            type="button"
            class="btn-side-up"
            @click="this.scrollMove(-160)"
          >
            위로<span class="overlay"></span>
          </button>
          <button
            type="button"
            class="btn-side-down"
            @click="this.scrollMove(160)"
          >
            아래로<span class="overlay"></span>
          </button>
        </div>
      </div>
    </div>
    <div class="pop-btn-area">
      <!-- [팝업버튼 크기] .btn-pop: 100%, .btn-pop.btn-half: 50%, .btn-pop.btn-third: 33.33%, .btn-pop.btn-fourth: 25% -->
      <button
        type="button"
        class="btn-pop btn-fourth btn-main"
        @click="$.emit('close')"
      >
        이전<span class="overlay"></span>
      </button>
      <button
        type="button"
        class="btn-pop btn-etc btn-yellow"
        @click="$.emit('rePrint')"
      >
        재출력<span class="overlay"></span>
      </button>
      <button
        type="button"
        class="btn-pop btn-etc btn-yellow"
        @click="$.emit('reOrder')"
      >
        반품<span class="overlay"></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "receiptDetail",
  props: {
    receipt: Object,
  },
  data() {
    return {
      date: "",
    };
  },
  methods: {
    scrollMove(moveY) {
      var scroll = document.getElementById("receiptArea");
      scroll.scrollTo({ top: scroll.scrollTop + moveY, behavior: "smooth" });
    },
  },
  watch: {},
  computed: {
    menuArr() {
      let arr = JSON.parse(this.receipt.desc).menuArr;
      let convertArr = new Array();
      arr.forEach((item) => {
        let cnt = convertArr.filter(
          (item2) => item2.menuIdx == item.menuIdx && item2.price == item.price
        ).length;

        if (cnt == 0) {
          convertArr.push({
            menuIdx: item.menuIdx,
            name: item.name,
            price: item.price,
            qty: item.qty,
            discount: item.discount,
          });
        } else {
          convertArr.filter(
            (item2) =>
              item2.menuIdx == item.menuIdx && item2.price == item.price
          )[0].qty += item.qty;
        }
      });

      return convertArr;
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped></style>


